module.exports = __webpack_public_path__ + "asset/image-Pill-268dc5bbcaa032d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Pill.svg
// module id = ysNX
// module chunks = 0